import { render, staticRenderFns } from "./roleGe.vue?vue&type=template&id=736ff78e&"
import script from "./roleGe.vue?vue&type=script&lang=js&"
export * from "./roleGe.vue?vue&type=script&lang=js&"
import style0 from "./roleGe.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports